import React, { useEffect, useState } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import styled from '@emotion/styled';
import Utils from '../Utility';
import { Button } from "reactstrap";
// import CustomAvatar from '../TableComponents/CustomAvatar'
// import { ReactComponent as RedArrow } from '../../assets/icons/High.svg'
// import { ReactComponent as YellowArrow } from '../../assets/icons/Medium.svg'
// import { ReactComponent as BlueArrow } from '../../assets/icons/Low.svg'



const TaskCard = ({ item, index, user, columnId, handleArchivedLead, setCurrentLead, setIsAddForm, history }) => {

    const [TaskInformation, setTaskInformation] = useState(styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 15px;
  min-height: 106px;
  border-radius: 5px;
  max-width: 311px;
  background: ${Utils.themeColor};
  margin-top: 15px;

  p {
      color:#fff;
  }

  .secondary-details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: 12px;
    font-weight: 400px;
    color: #7d7d7d;
  }
  /* .priority{ */
  /* margin-right: 12px; */
  /* align-self: center;
    svg{
      width: 12px !important;
      height: 12px !important;
      margin-right: 12px; */
  /* margin-top: 2px; */
  /* } */
  /* } */
`);

    useEffect(() => {
        if (user.companyId)
            setTaskInformation(styled.div`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            padding: 10px 15px;
            min-height: 106px;
            border-radius: 5px;
            max-width: 311px;
            background: ${user?.company.theme ? user?.company.theme : Utils.themeColor};
            margin-top: 15px;
          
            p {
                color:#fff;
            }
          
            .secondary-details {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              font-size: 12px;
              font-weight: 400px;
              color: #7d7d7d;
            }
            /* .priority{ */
            /* margin-right: 12px; */
            /* align-self: center;
              svg{
                width: 12px !important;
                height: 12px !important;
                margin-right: 12px; */
            /* margin-top: 2px; */
            /* } */
            /* } */
          `)
    }, [user]);

    return (
        <Draggable key={item._id} draggableId={item._id} index={index}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <TaskInformation>
                        <div className="d-flex" style={{ width: '100%' }}>
                            <p style={{ fontSize: 20 }}>{item.name}</p>
                            <span onClick={() => history.push('/lead/'+item?._id)}
                                title={"Details"}
                                className="mdi mdi-eye" style={{ fontSize: 20, color: '#fff', marginLeft: 'auto', cursor: 'pointer' }}></span>
                            {user?.role == 'Admin' || item.addedBy == user?._id ?
                                <span onClick={() => { setCurrentLead(item); setIsAddForm(true) }}
                                    title={"Update"}
                                    className="mdi mdi-pencil" style={{ fontSize: 20, color: '#fff', marginLeft: 10, marginRight: 5, cursor: 'pointer' }}></span>
                                    : null
                            }
                            {user?.role == 'Admin' &&
                                <span onClick={() => handleArchivedLead(item)}
                                    title={"Archive"}
                                    className="mdi mdi-archive-arrow-down" style={{ fontSize: 20, color: '#fff', marginLeft: 5, marginRight: 5, cursor: 'pointer' }}></span>
                            }
                        </div>
                        <p>{item.intro.length > 65 ? item.intro.substring(0, 65) + "..." : item.intro}</p>
                        <div className="secondary-details">
                            <p>
                                <span>
                                    {new Date(item.createdAt).toLocaleDateString('en-us', {
                                        month: 'short',
                                        day: '2-digit',
                                    })}
                                </span>
                            </p>
                            {columnId != 0 &&
                                <p>
                                    <span style={{ borderWidth: 1, borderColor: '#fff' }}>
                                        {item?.status}
                                    </span>
                                </p>
                            }
                        </div>
                    </TaskInformation>
                </div>
            )}
        </Draggable>
    );
};

export default TaskCard;